import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    defaultLabelButton: {
      '& .MuiButton-label': {
        lineHeight: '15px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
      },
    },
  };
});